module.exports = __webpack_public_path__ + "img/director-work-icon2.5965c0a0.png";